import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { Icon } from "@syarahtech/ui";
import Markdown from "markdown-to-jsx";
export default function WarrantyTrigger(_ref) {
  var _data$items, _items, _displaySelected$head, _displaySelected$head2, _displaySelected$head3, _displaySelected$head4;
  var data = _ref.data,
    selectedItem = _ref.selectedItem,
    onClick = _ref.onClick,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? "bg-[#f0f0fc]" : _ref$bgColor,
    _ref$titleSize = _ref.titleSize,
    titleSize = _ref$titleSize === void 0 ? "text-[13px]" : _ref$titleSize,
    _ref$subtitleSize = _ref.subtitleSize,
    subtitleSize = _ref$subtitleSize === void 0 ? "text-sm" : _ref$subtitleSize;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    tShort = _useTranslation.tShort;

  // Don't render if items aren't ready — data.selected can be null when
  // no item is pre-selected in the API response, so guard on selectedItem instead.
  if (!(data !== null && data !== void 0 && (_data$items = data.items) !== null && _data$items !== void 0 && _data$items.length) || !selectedItem) return null;
  var items = data.items;
  var lastItemId = (_items = items[items.length - 1]) === null || _items === void 0 ? void 0 : _items.id;
  var isHighestSelected = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === lastItemId;

  // data.selected has richer display fields (icon, header); fall back to no-warranty state
  var displaySelected = data.selected;
  var isNoWarrantyState = !displaySelected;

  // For no-warranty state: find the item with a badge to feature in the subtitle
  var badgedItem = isNoWarrantyState ? items.find(function (i) {
    return !!i.badge;
  }) : null;
  var displayTitle = (_displaySelected$head = displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head2 = displaySelected.header) === null || _displaySelected$head2 === void 0 ? void 0 : _displaySelected$head2.title) !== null && _displaySelected$head !== void 0 ? _displaySelected$head : tShort("warranty/no_warranty_title", {
    ns: "web_checkout_cash"
  });

  // Subtitle: show "مدد ضمانك ل {badgedItem.title}" only if a badged item exists
  var displaySubtitle = (_displaySelected$head3 = displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head4 = displaySelected.header) === null || _displaySelected$head4 === void 0 ? void 0 : _displaySelected$head4.subtitle) !== null && _displaySelected$head3 !== void 0 ? _displaySelected$head3 : badgedItem ? "".concat(tShort("warranty/no_warranty_subtitle", {
    ns: "web_checkout_cash"
  }), " ").concat(badgedItem.title) : null;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: "w-full cursor-pointer focus:outline-none "
  }, /*#__PURE__*/React.createElement("div", {
    className: "gap-1 flex items-center rounded-lg border-solid border-[1px] border-[#8E47E0] ".concat(bgColor, " px-[6px] py-[10px] hover:bg-[#e8e8f8] transition-colors")
  }, (displaySelected === null || displaySelected === void 0 ? void 0 : displaySelected.icon) && /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement("img", {
    src: displaySelected.icon,
    width: "40",
    height: "45"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end text-start flex-1 min-w-0"
  }, displayTitle && /*#__PURE__*/React.createElement("p", {
    className: "text-black ".concat(titleSize, " leading-6 break-words w-full text-start")
  }, /*#__PURE__*/React.createElement(Markdown, null, displayTitle)), displaySubtitle && /*#__PURE__*/React.createElement("p", {
    className: "".concat(selectedItem !== null && selectedItem !== void 0 && selectedItem.is_default ? "text-[#00143C] text-[12px]" : subtitleSize + " text-[#8E47E0]", " leading-6 break-words w-full text-start")
  }, /*#__PURE__*/React.createElement(Markdown, null, displaySubtitle))), /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, isHighestSelected && !isNoWarrantyState ? /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--edit-square-outline",
    className: "text-primary-new px-1",
    width: 5,
    height: 5
  }) : /*#__PURE__*/React.createElement("div", {
    className: "flex gap-1 rounded-[4px] bg-primary-new px-1 py-2 items-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-white text-[11px] leading-tight whitespace-nowrap"
  }, tShort("warranty/extend_now")), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add",
    className: "text-white px-1",
    width: 4,
    height: 4
  })))));
}